(() => {
  const DEFAULT_QUERY = 'Engagement Rings';
  const processedLayers = new WeakSet();

  function triggerDoofinderSearch(root) {
    if (!root || processedLayers.has(root)) return;

    const input = root.querySelector('.dfd-searchbox-input');
    const form = root.querySelector('.dfd-searchbox');

    if (!input || !form || input.value.trim()) return;

    processedLayers.add(root);

    input.focus();

    /*
     * Use the native value setter so Doofinder's reactive interface
     * recognises the change rather than treating it as a DOM-only edit.
     */
    const nativeValueSetter = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      'value'
    )?.set;

    if (nativeValueSetter) {
      nativeValueSetter.call(input, DEFAULT_QUERY);
    } else {
      input.value = DEFAULT_QUERY;
    }

    input.dispatchEvent(
      new InputEvent('input', {
        bubbles: true,
        inputType: 'insertText',
        data: DEFAULT_QUERY
      })
    );

    input.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );

    /*
     * Doofinder normally searches from its input event. This form submit
     * is a fallback in case the live search event does not fire.
     */
    window.setTimeout(() => {
      if (
        root.getAttribute('data-dfd-screen') === 'fullscreen-initial'
      ) {
        form.dispatchEvent(
          new Event('submit', {
            bubbles: true,
            cancelable: true
          })
        );
      }
    }, 250);
  }

  function findOpenDoofinderLayers() {
    document
      .querySelectorAll(
        '.dfd-root[data-dfd-view="Search"][data-dfd-screen="fullscreen-initial"]'
      )
      .forEach(triggerDoofinderSearch);
  }

  const observer = new MutationObserver(() => {
    findOpenDoofinderLayers();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-dfd-screen']
  });

  findOpenDoofinderLayers();
})();